import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { CheckListTwoIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { submitMissionToStaffReport } from '../../api/mission-to-staffs/submit-mission-to-staff-report'
import UserNavBar from '../../components/elements/nav-bar'
import MissionToStaffReportForm from '../../components/pages/mission-to-staff-report/mission-to-staff-report-form'
import { Paths } from '../../lib/constants/path'
import useAuth from '../../lib/hooks/use-auth'
import useTranslate from '../../lib/hooks/use-translate'
import { modalButtonConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { StaffMissionReportHeader } from './staff-mission-report-header'

export function StaffMissionReportPage() {
  const { t } = useTranslate()
  const { user } = useAuth()
  const id = useParams().id
  const staffId = user?.staff?.id
  const { navigate } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: submitMissionToStaffReport
  })

  if (!staffId || !id) return null

  return (
    <div className="flex flex-col gap-5">
      <UserNavBar
        title={t('staff.personal.space.missions.report.title')}
        icon={(props) => <CheckListTwoIcon {...props} color={tailwindColors.fushia.DEFAULT} />}
      />

      <Box className="px-5 py-6">
        <StaffMissionReportHeader missionToStaffId={Number(id)} />
        <div className="h-4"></div>
        <Box className="border border-grey-light">
          <MissionToStaffReportForm
            buttonsConfig={modalButtonConfig({
              onConfirm: async (data) => {
                await mutateAsync({ id: Number(id), ...data })
                navigate(Paths.STAFF_PERSONAL_SPACE_MISSIONS, { replace: true })
              },
              onCancel: () => navigate(Paths.STAFF_PERSONAL_SPACE_MISSIONS, { replace: true })
            })}
          />
        </Box>
      </Box>
    </div>
  )
}
